const APP_EVENT = 'trackCustomEvent';

// trigger custom event
// apphub will capture and push this to sensor
function apptracker(data) {
  const { action } = data;
  const event: any = new CustomEvent(APP_EVENT, {
    detail: {
      name: action,
      data: JSON.stringify(data),
    },
  });
  document.dispatchEvent(event);
}

export default apptracker;
